// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Footer Styles */
.footer {
  margin-top: 40px;
  padding: 20px;
  background: linear-gradient(180deg, #2d2d2d 0%, #242424 100%);
  border-radius: 4px;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.05),
    inset 0 -1px 0 rgba(0, 0, 0, 0.3),
    0 2px 8px rgba(0, 0, 0, 0.4);
  border: 1px solid #3a3a3a;
  position: relative;
}

.footer::before {
  content: '';
  position: absolute;
  top: 4px;
  left: 4px;
  right: 4px;
  height: 2px;
  background: linear-gradient(90deg, transparent, rgba(212, 165, 116, 0.3), transparent);
  border-radius: 1px;
}

.footer-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
}

.footer-links {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px 24px;
}

.footer-link {
  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: #8a8578;
  text-decoration: none;
  transition: color 0.2s ease;
  letter-spacing: 0.5px;
}

.footer-link:hover {
  color: #c9a227;
}

.footer-copyright {
  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;
  font-size: 11px;
  font-weight: 400;
  color: #6a6558;
  letter-spacing: 0.5px;
}

/* ===== Landing page footer overrides ===== */
.footer--landing {
  background: #111111;
  border: none;
  border-radius: 0;
  box-shadow: none;
  margin-top: 0;
  padding: 48px 20px 32px;
  border-top: 1px solid #222;
}

.footer--landing::before {
  display: none;
}

.footer--landing .footer-content {
  gap: 12px;
}

.footer--landing .footer-links {
  gap: 0;
}

.footer--landing .footer-link {
  font-size: 13px;
  color: #888;
  padding: 0 12px;
  border-right: 1px solid #444;
}

.footer--landing .footer-link:last-child {
  border-right: none;
}

.footer--landing .footer-link:hover {
  color: #ccc;
}

.footer--landing .footer-copyright {
  font-size: 12px;
  color: #666;
}

/* Responsive design */
@media (max-width: 768px) {
  .footer {
    margin-top: 24px;
    padding: 64px 16px;
  }

  .footer-content {
    gap: 28px;
  }

  .footer-links {
    gap: 8px 16px;
    font-size: 11px;
  }

  .footer-link {
    font-size: 11px;
  }

  .footer-copyright {
    font-size: 10px;
  }

  .footer--landing {
    padding: 32px 16px 24px;
  }

  .footer--landing .footer-links {
    flex-wrap: wrap;
    gap: 8px 0;
  }
}

@media (max-width: 480px) {
  .footer-links {
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }

  .footer--landing .footer-link {
    border-right: none;
    padding: 4px 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/client/components/Footer.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,aAAa;EACb,6DAA6D;EAC7D,kBAAkB;EAClB;;;gCAG8B;EAC9B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,sFAAsF;EACtF,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,4DAA4D;EAC5D,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4DAA4D;EAC5D,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA,8CAA8C;AAC9C;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,UAAU;EACZ;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;AACF","sourcesContent":["/* Footer Styles */\n.footer {\n  margin-top: 40px;\n  padding: 20px;\n  background: linear-gradient(180deg, #2d2d2d 0%, #242424 100%);\n  border-radius: 4px;\n  box-shadow:\n    inset 0 1px 0 rgba(255, 255, 255, 0.05),\n    inset 0 -1px 0 rgba(0, 0, 0, 0.3),\n    0 2px 8px rgba(0, 0, 0, 0.4);\n  border: 1px solid #3a3a3a;\n  position: relative;\n}\n\n.footer::before {\n  content: '';\n  position: absolute;\n  top: 4px;\n  left: 4px;\n  right: 4px;\n  height: 2px;\n  background: linear-gradient(90deg, transparent, rgba(212, 165, 116, 0.3), transparent);\n  border-radius: 1px;\n}\n\n.footer-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 32px;\n}\n\n.footer-links {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 8px 24px;\n}\n\n.footer-link {\n  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;\n  font-size: 12px;\n  font-weight: 500;\n  color: #8a8578;\n  text-decoration: none;\n  transition: color 0.2s ease;\n  letter-spacing: 0.5px;\n}\n\n.footer-link:hover {\n  color: #c9a227;\n}\n\n.footer-copyright {\n  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;\n  font-size: 11px;\n  font-weight: 400;\n  color: #6a6558;\n  letter-spacing: 0.5px;\n}\n\n/* ===== Landing page footer overrides ===== */\n.footer--landing {\n  background: #111111;\n  border: none;\n  border-radius: 0;\n  box-shadow: none;\n  margin-top: 0;\n  padding: 48px 20px 32px;\n  border-top: 1px solid #222;\n}\n\n.footer--landing::before {\n  display: none;\n}\n\n.footer--landing .footer-content {\n  gap: 12px;\n}\n\n.footer--landing .footer-links {\n  gap: 0;\n}\n\n.footer--landing .footer-link {\n  font-size: 13px;\n  color: #888;\n  padding: 0 12px;\n  border-right: 1px solid #444;\n}\n\n.footer--landing .footer-link:last-child {\n  border-right: none;\n}\n\n.footer--landing .footer-link:hover {\n  color: #ccc;\n}\n\n.footer--landing .footer-copyright {\n  font-size: 12px;\n  color: #666;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .footer {\n    margin-top: 24px;\n    padding: 64px 16px;\n  }\n\n  .footer-content {\n    gap: 28px;\n  }\n\n  .footer-links {\n    gap: 8px 16px;\n    font-size: 11px;\n  }\n\n  .footer-link {\n    font-size: 11px;\n  }\n\n  .footer-copyright {\n    font-size: 10px;\n  }\n\n  .footer--landing {\n    padding: 32px 16px 24px;\n  }\n\n  .footer--landing .footer-links {\n    flex-wrap: wrap;\n    gap: 8px 0;\n  }\n}\n\n@media (max-width: 480px) {\n  .footer-links {\n    flex-direction: column;\n    align-items: center;\n    gap: 8px;\n  }\n\n  .footer--landing .footer-link {\n    border-right: none;\n    padding: 4px 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
